// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-enter-active[data-v-7c6db920],.slide-leave-active[data-v-7c6db920]{transform:translate(0) translateZ(1px);transition:transform 225ms cubic-bezier(0,0,.2,1) 0ms}.slide-enter-from[data-v-7c6db920],.slide-leave-to[data-v-7c6db920]{transform:translateY(100vh) translateY(0) translateZ(1px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
